import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TextInput from '@xingternal/malt-text-input';
import { PrimaryButtonMedium as Button } from '@xingternal/malt-button';

import PageviewTracker from './../../../Components/PageviewTracker/PageviewTracker';
import StretchButtonGroup from './../../../Components/StretchButtonGroup/StretchButtonGroup';
import FormMessage from './../../../Components/FormMessage/FormMessage';
import Spacer from './../../../Components/Spacer/Spacer';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';
import CustomTextButton from './../../../Components/CustomMalt/TextButton';

import messages from './messages';

const ActiveEmailStep = ({
  handleChange,
  genericError,
  isSubmitting,
  values: { activeEmail },
  errors,
}) => (
  <>
    <PageviewTracker pageName={'wbm/Welcome/login/recovery/account'} />

    <CustomH>
      <FormattedMessage {...messages.title} />
    </CustomH>

    <CustomP>
      <FormattedMessage {...messages.description} />
    </CustomP>

    <TextInput
      name={'activeEmail'}
      onChange={handleChange}
      label={<FormattedMessage {...messages.inputLabel} />}
      value={activeEmail}
      message={errors.activeEmail}
      type={'text'}
      size={'m'}
      required
      autoFocus
      readOnly={isSubmitting}
      disabled={isSubmitting}
    />

    <FormMessage error={genericError} />

    <StretchButtonGroup>
      <Button loading={isSubmitting} type={'submit'}>
        <FormattedMessage {...messages.buttonContinue} />
      </Button>

      <Spacer size={2} />

      <CustomTextButton isPetrol to={'/recovery/account/forgot-credentials'}>
        <FormattedMessage {...messages.forgotCredentialsRecoveryLabel} />
      </CustomTextButton>
    </StretchButtonGroup>
  </>
);

ActiveEmailStep.propTypes = {
  handleChange: PropTypes.func,
  genericError: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
    description: PropTypes.oneOf[(PropTypes.string, PropTypes.object)],
  }),
  isSubmitting: PropTypes.bool,
  values: PropTypes.shape({ activeEmail: PropTypes.string }),
  errors: PropTypes.object,
};

export default ActiveEmailStep;
